import dayjs, { Dayjs } from 'dayjs';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface CloseContextState {
  entitySetId: string;
  closePeriod: Dayjs;
  setEntitySetId: (entitySetId: string) => void;
  setClosePeriod: (period: Dayjs) => void;
}

// Internal persisted state (Dayjs stored as ISO string)
interface PersistedState {
  entitySetId: string;
  closePeriod: string;
}

const useCloseContextStore = create<CloseContextState>()(
  persist(
    (set) => ({
      entitySetId: '',
      closePeriod: dayjs(),
      setEntitySetId: (entitySetId) => set({ entitySetId }),
      setClosePeriod: (closePeriod) => set({ closePeriod }),
    }),
    {
      name: 'close-context-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state: CloseContextState): PersistedState => ({
        entitySetId: state.entitySetId,
        closePeriod: state.closePeriod.toISOString(),
      }),
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        const persistedState = state as unknown as PersistedState;
        if (
          persistedState.closePeriod &&
          dayjs(persistedState.closePeriod).isValid()
        ) {
          state.closePeriod = dayjs(persistedState.closePeriod);
        } else {
          state.closePeriod = dayjs();
        }
      },
    }
  )
);
export { useCloseContextStore };
